module.exports = __webpack_public_path__ + "img/fee0139.jpg";